import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=e5dc60d0&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.scss?vue&type=style&index=0&id=e5dc60d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc60d0",
  null
  
)

export default component.exports